import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const WitnessCard = {
    label: "Carte de témoignage",
    type: ContentsCustomTypes.WITNESS_CARD,
    editionModal: true,
    editionModalPosition: "top",
    icon: "comment-alt-smile",
    children: [
        {
            label: "Couleur de l'icône",
            key: "iconColor",
            type: ContentsTypes.COLOR,
            value: "",
        },
        {
            label: "Témoignage",
            key: "witness",
            type: ContentsTypes.SHORT_TEXT,
            value: "",
        },
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Nom",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Fonction",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
